export enum EBaseUrl {
  envLetter = "https://gift.haypost.am/API",
  envDelivery = "https://apidelivery.haypost.am",
  envClientKey = "f5d6c4e9-d126-4dc4-8e47-ae7c1ba48a6b",
  envHash = "243871c7-8679-40e7-85b2-853e6c0b3ff9",
}
